import {actionCreator} from "../../helpers/actionCreator";
import * as ActionTypes from "./types";

export const fastScanBadge = actionCreator(ActionTypes.FAST_SCAN_BADGE)
export const fastScanBadgeSucceeded = actionCreator(ActionTypes.FAST_SCAN_BADGE_SUCCEEDED)
export const fastScanBadgeFailed = actionCreator(ActionTypes.FAST_SCAN_BADGE_FAILED)

export const clearScannedBadge = actionCreator(ActionTypes.CLEAR_SCANNED_BADGE)
